import React, {useEffect, useState} from "react";
import Toolbar, {Item} from 'devextreme-react/toolbar';
import {inject, observer} from "mobx-react";
import './header-control.css'
import Avatar from "@material-ui/core/Avatar";
import {useHistory} from "react-router-dom";
import PersonIcon from '@material-ui/icons/Person';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {auth} from "../../../firebase/Firebase";
import {useSnackbar} from "notistack";
import {ErrorMessage, NotiStackInfo} from "../../../palette/NotiStackInfo";
import Text from "../../../palette/Text";
import {LayoutChild} from "../../../palette/Palette";
import {withStyles} from '@material-ui/core/styles';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import DoneAllIcon from '@material-ui/icons/DoneAll';

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
        padding: 5
    },
})((props) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));

const StyledMenuItem = withStyles((theme) => ({
    root: {
        '&:focus': {
            backgroundColor: '#01A0EC',
            '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                color: theme.palette.common.white,
            },
        },
    },
}))(MenuItem);


function HeaderControl(props) {

    const {DataStore, SessionStore} = props;

    const {openDrawer, imageAsUrl, userName, tabs} = DataStore

    const [defaultVisible, setDefaultVisible] = useState(false)
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [showWelcome, setShowWelcome] = useState(true)

    useEffect(() => {
        setShowWelcome(true)
        setTimeout(() => setShowWelcome(false), 10000)
    }, [])

    let history = useHistory();

    const {enqueueSnackbar} = useSnackbar();


    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const menuButton = {
        icon: 'menu',
        elementAttr: {id: 'bt-open-drawer'},
        onClick: () => DataStore.getValueOpenDrawer(!openDrawer)
    };

    const toggleDefault = () => {
        setDefaultVisible(!defaultVisible)
    }

    const signOut = async () => {
        await auth.signOut().then(function () {
            SessionStore.handleLogoutUser(false)
            setTimeout(() => history.push('/'), 50)
            NotiStackInfo('Saliendo...', 'success', enqueueSnackbar)
        }).catch(function () {
            NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
        });
    }

    const tabsLabel = () => {
        return (
            <Text hover={false} text={tabs} weight={'700'} size={20} left={15}/>
        )
    }

    const welcomeRender = () => {
        return (
            <LayoutChild row center left={15} color={'#29B6F6'} padding={5} radius={5}>
                <DoneAllIcon style={{color: 'white'}}/>
                <Text hover={false} color={'white'} text={'Bienvenido'} weight={'700'} left={7}/>
            </LayoutChild>
        )
    }

    const logo = () => {
        return (
            <div onMouseEnter={toggleDefault} onMouseLeave={toggleDefault} style={{cursor: 'pointer', marginRight: 15}}>
                <div style={{display: 'flex', alignItems: 'center'}}>
                    {imageAsUrl ?
                        <Avatar alt="" src={imageAsUrl} style={{width: 30, height: 30}} onClick={handleClick}/> :
                        <PersonIcon onClick={handleClick}
                                    style={{
                                        width: 40,
                                        height: 40,
                                        backgroundColor: '#3A7DB5',
                                        color: 'white',
                                        borderRadius: 20,
                                        marginBottom: 5
                                    }}/>
                    }
                </div>

                <StyledMenu
                    id="customized-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <StyledMenuItem onClick={() => history.push('/control-panel/user-profile')}>
                        <ListItemIcon>
                            <AccountBoxIcon fontSize="small"/>
                        </ListItemIcon>
                        <ListItemText primary="Perfil"/>
                    </StyledMenuItem>
                    <StyledMenuItem onClick={signOut}>
                        <ListItemIcon>
                            <ExitToAppIcon fontSize="small"/>
                        </ListItemIcon>
                        <ListItemText primary="Salir"/>
                    </StyledMenuItem>
                </StyledMenu>
            </div>
        )
    }

    const companyRender = () => {
        return (
            <LayoutChild column>
                <Text hover={false} text={DataStore.companyName} size={14} weight={'700'}/>
                <Text hover={false} text={userName}/>
            </LayoutChild>
        )
    }

    return (
        <header>
            <div className={'header-panel-control'}>
                <Toolbar elementAttr={{id: 'toolbar-control-panel'}}>
                    <Item
                        widget={'dxButton'}
                        location={'before'}
                        options={menuButton}
                    />
                    {showWelcome && <Item location={'before'} render={welcomeRender}/>}
                    <Item location={'before'} render={tabsLabel}/>
                    <Item location={'after'} render={companyRender}/>
                    <Item location={'after'} render={logo}/>
                </Toolbar>
            </div>
        </header>
    )
}

export default (inject('DataStore', 'SessionStore'))(observer(HeaderControl))

